export enum EPrescriptionsType {
  BuyInternal,
  BuyOutside
}
